import React, { FC } from 'react';
import { Loader } from 'shared/components/Loader';
import { Backdrop as MuiBackdrop } from '@mui/material';

interface BackdropProps {
  position?: 'fixed' | 'absolute';
}

export const Backdrop: FC<BackdropProps> = ({ position = 'fixed' }) => {
  return (
    <MuiBackdrop open sx={{ color: '#fff', zIndex: 100, position }}>
      <Loader />
    </MuiBackdrop>
  );
};
